import request from "@/utils/request";

export function getGiftCards(storeName) {
  return request({
    url: `url/${storeName}`,
    method: "get",
  });
}

export function getServices() {
  return request({
    url: "services",
  });
}

export function getTechnician(storeName) {
  return request({
    url: `user/assignee?store_name=${storeName}`,
  });
}

export function createTicket(body) {
  return request({
    url: "ticket",
    method: "post",
    data: body,
  });
}
